<template>
  <div class="authority-tree">
    <tree-node
      :treeData="treeData"
      :distanceIndex="1"
      :point="point"
      @toEdit="toEdit"
    ></tree-node>
    <a-button type="primary" @click="saveAuthorityConfig">保存配置</a-button>
  </div>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
  >
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "@/utils/index";
import TreeNode from "@/views/mobileMenu/components/modal/tree.vue";
import {
  getPermissionTree,
  getPermissionsByUserId,
  insertPermissionUser,
} from "@/request/view/permissions";
import store from "@/store";

export default defineComponent({
  components: { TreeNode },
  setup() {
    const router = useRouter();
    const treeData = reactive([]);
    const point = reactive({});
    const userSelectMenu = ref([]);
    const modalConfig = reactive({
      visible: false,
      title: "",
    });
    const getPoint = (arr) => {
      arr.forEach((menu) => {
        menu.active = false;
        point[menu.id] = menu;
        if (menu.children && menu.children.length > 0) {
          getPoint(menu.children);
        }
      });
    };
    // 权限的方法
    const checkMenuOrPerssion = (list) => {
      list.forEach((item) => {
        if (item.type === "1") {
          item.slots = { title: "custom" };
        } else if (item.type === "2") {
          item.slots = { title: "cud" };
        }
        return item.children && item.children.length > 0
          ? checkMenuOrPerssion(item.children)
          : false;
      });
    };

    const getTreeData = () => {
      return new Promise((resolve, reject) => {
        getPermissionTree()
          .then((res) => {
            treeData.length = 0;
            if (res.code === 200 && res.message === "成功") {
              checkMenuOrPerssion(res.data);
              treeData.push(...res.data);
              getPoint(treeData);
              resolve();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    // 修改菜单信息
    const toEdit = (item) => {
      console.log();
    };
    // 确认修改
    const handleOk = () => {
      console.log();
    };

    const getPersonAuthrity = (data) => {
      getPermissionsByUserId({ userId: data.id }).then((res) => {
        Object.keys(point).forEach((key) => {
          point[key].active = false;
        });
        res.data.forEach((item) => {
          point[item].active = true;
        });
        userSelectMenu.value.length = 0;
        userSelectMenu.value.push(...res.data);
      });
    };

    let userId = "";
    const setSaleAuthority = (data) => {
      getTreeData().then(() => {
        userId = data.id;
        getPersonAuthrity(data);
      });
    };

    // 保存配置
    const saveAuthorityConfig = () => {
      const arr = [];
      Object.keys(point).forEach((key) => {
        if (point[key].active) {
          arr.push(point[key].id);
        }
      });
      console.log(userId);
      insertPermissionUser({userId}, arr)
        .then((res) => {
          if (res.code === 200 && res.message === "权限添加成功") {
            Toast("success", "提示", "修改权限成功", 3);
          } else if (res.code === 400) {
            Toast("error", "提示", res.message, 3);
          }
          setTimeout(() => {
            router.back();
          }, 500);
        })
        .catch((err) => {
          router.back();
        });
    };

    return {
      point,
      toEdit,
      treeData,
      modalConfig,
      handleOk,
      setSaleAuthority,
      saveAuthorityConfig,
    };
  },
});
</script>

<style lang="less" scoped>
.authority-tree {
  padding: 0 .4rem;
}
</style>
